import { render } from "./LoadingIcon.vue?vue&type=template&id=7c628192&scoped=true"
import script from "./LoadingIcon.vue?vue&type=script&lang=ts"
export * from "./LoadingIcon.vue?vue&type=script&lang=ts"

import "./LoadingIcon.vue?vue&type=style&index=0&id=7c628192&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7c628192"

export default script